import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'family-relationship',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule
  ],
  templateUrl: './family-relationship.component.html',
  styleUrl: './family-relationship.component.css'
})
export class FamilyRelationshipComponent implements OnInit {

  @Input() parentInterviewData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  yesNo = EYesNo;
  familyRelationshipForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Who lives in the home? *",
      formControlName: "home_life",
      placeholder: "E.g. mom, dad, brother, sister"
    },
    {
      question: "Are there any important events that have affected your family or child such as: *",
      formControlName: "important_events",
      placeholder: "E.g. Relocation, Divorce or separation, Death or serious illness, Career or financial issues, Legal issues"
    },
    {
      question: "Who does your child talk to about concerns? *",
      formControlName: "child_talk_concerns",
      placeholder: "Type here"
    },
    {
      question: "How well does he/she get along with you? *",
      formControlName: "child_parent_relationship",
      placeholder: "Type here"
    },
    {
      question: "How well does he/she get along with siblings? *",
      formControlName: "child_sibling_relationship",
      placeholder: "Type here"
    },
    {
      question: "How is conflict in the family usually resolved? *",
      formControlName: "family_conflict",
      placeholder: "Type here"
    },
    {
      question: "How does your child show anger toward you and other family members? *",
      formControlName: "child_anger",
      placeholder: "Type here"
    },
    {
      question: "What does your child do after school? *",
      formControlName: "child_after_school",
      placeholder: "Type here"
    },
    {
      question: "Who supervises him/her? *",
      formControlName: "supervision",
      placeholder: "Type here"
    },
    {
      question: "What time is he/she expected home? *",
      formControlName: "home_expectation",
      placeholder: "Type here"
    },
    {
      question: "What responsibilities does your child have at home? *",
      formControlName: "child_responsibilities",
      placeholder: "Type here"
    },
    {
      question: "What are the consequences for not following the rules? *",
      formControlName: "consequences",
      placeholder: "Type here"
    },
  ]
  radioQuestions = [
    {
      id: 'child_rules',
      questionText: "Does your child follow rules? *",
      formControlName: 'child_rules',
      infoFormControlName: 'child_rules_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.Yes;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.familyRelationshipForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.familyRelationshipForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.familyRelationshipForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.No);
          }          
        });
      }
    });
  }

  saveFamilyRelationship(): void {
    if (this.familyRelationshipForm.valid) {
      this.onSaveSection4.emit(this.familyRelationshipForm.value);
    }
  }

}
